export function parseErrorMessage(error) {
  return (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message
}



// WEBPACK FOOTER //
// ./src/utils/utils.js